import { useContext } from 'react'
import InvoiceUploadContext from '../../contexts/invoice-upload/InvoiceUploadContext'

const useInvoiceUploadContext = () => {
    return useContext(InvoiceUploadContext)
}

export default useInvoiceUploadContext